import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./VideoSection.css";

const VideoSection = () => {
  return (
    /* 
      `fluid` ensures this section spans full width.
      Remove `fluid` if you prefer a standard-width container.
    */
    <Container fluid className="video-section">
      {/* Heading row */}
      <Row>
        <Col xs={12} className="text-center">
          <h2 className="section-title">Our AI Solutions</h2>
        </Col>
      </Row>

      {/* 
        Videos row:
        - Use `g-4` for built-in Bootstrap spacing between columns (gx + gy).
        - `justify-content-center` centers columns if they don't fill the row.
      */}
      <Row className="g-4 justify-content-center">
        {/* First Video */}
        <Col xs={12} md={6} lg={4} className="video-item">
          <video autoPlay muted loop className="solution-video">
            <source
              src={process.env.PUBLIC_URL + "/videos/cars_system.mp4"}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <p className="video-description">Smart Transportation System</p>
        </Col>

        {/* Second Video */}
        <Col xs={12} md={6} lg={4} className="video-item">
          <video autoPlay muted loop className="solution-video">
            <source
              src={process.env.PUBLIC_URL + "/videos/shoppers.mp4"}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <p className="video-description">Retail Monitoring System</p>
        </Col>

        {/* Third Video */}
        <Col xs={12} md={6} lg={4} className="video-item">
          <video autoPlay muted loop className="solution-video">
            <source
              src={process.env.PUBLIC_URL + "/videos/illinta.mp4"}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <p className="video-description">Smart Agriculture</p>
        </Col>
      </Row>
    </Container>
  );
};

export default VideoSection;
